(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@mobi-components/global-solution'), require('uuid')) :
    typeof define === 'function' && define.amd ? define(['exports', '@mobi-components/global-solution', 'uuid'], factory) :
    (global = global || self, factory(global['bluesky-utils'] = {}, global.globalSolution, global.uuid));
}(this, (function (exports, globalSolution, uuid) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    (function (TripIntent) {
        TripIntent["MUST_SEE"] = "MUST SEE";
        TripIntent["COULD_SEE"] = "COULD SEE";
        TripIntent["MAYBE"] = "MAYBE";
        TripIntent["NONE"] = "";
    })(exports.TripIntent || (exports.TripIntent = {}));
    (function (RecommendationCategory) {
        RecommendationCategory["FOR_YOU"] = "FOR_YOU";
        RecommendationCategory["FOR_TRIP"] = "FOR_TRIP";
        RecommendationCategory["FOR_CONTEXT"] = "FOR_CONTEXT";
    })(exports.RecommendationCategory || (exports.RecommendationCategory = {}));
    function convertIntentToPreference(intent) {
        switch (intent) {
            case exports.TripIntent.COULD_SEE:
                return globalSolution.CandidatePreference.INTERESTED;
            case exports.TripIntent.MAYBE:
                return globalSolution.CandidatePreference.MAYBE;
            case exports.TripIntent.MUST_SEE:
                return globalSolution.CandidatePreference.DEFINITELY;
            default:
                return globalSolution.CandidatePreference.INTERESTED;
        }
    }
    function convertActivityToRecommendation(activity, intent, category, location, contexts, prices, description, price_level) {
        var _a, _b, _c, _d;
        return __assign(__assign({}, activity), { prices: prices,
            price_level: price_level, originalId: ((_a = activity.source) === null || _a === void 0 ? void 0 : _a.candidate_id) || '', scheduled_end_time: activity.scheduled_end_time * 1000, scheduled_start_time: activity.scheduled_start_time * 1000, tags: [], intent: intent, context: category, contexts: [contexts], categories: [category], matchedFilters: ((_b = activity.spec) === null || _b === void 0 ? void 0 : _b.satisfied_filters) || [], explanations: activity.explanations, location: location, curated: ((_c = activity.spec) === null || _c === void 0 ? void 0 : _c.curated) || false, description: description, start_timestamp: activity.scheduled_start_time, end_timestamp: activity.scheduled_end_time, source_id: ((_d = activity.source) === null || _d === void 0 ? void 0 : _d.candidate_id) || '', url: '', website: '', photo: '', index: 0, preferred: false, preference: convertIntentToPreference(intent), recommendations: [] });
    }
    var getRecommendationContextFromActivity = function (activityDescription, favorites) {
        var selectedFavorites = favorites || [];
        var recommendationSource = selectedFavorites.find(function (x) { var _a; return ((_a = activityDescription.activity.source) === null || _a === void 0 ? void 0 : _a.candidate_id) === x.id; });
        return convertActivityToRecommendation(activityDescription.activity, recommendationSource ? recommendationSource.intent : exports.TripIntent.NONE, activityDescription.activity.category, activityDescription.startLocation || activityDescription.endLocation, '', (recommendationSource === null || recommendationSource === void 0 ? void 0 : recommendationSource.prices) || [], (recommendationSource === null || recommendationSource === void 0 ? void 0 : recommendationSource.description) || '', recommendationSource === null || recommendationSource === void 0 ? void 0 : recommendationSource.price_level);
    };
    function generateEmptyActivityItem(id, name, category, constraint, duration, description) {
        if (duration === void 0) { duration = 0; }
        if (description === void 0) { description = ''; }
        return {
            id: id,
            // @ts-ignore
            name: name,
            description: description,
            category: category,
            optional: false,
            candidate_information: null,
            allowed_incoming_modes: [],
            allowed_outgoing_modes: [],
            duration: duration,
            start_constraint_type: constraint,
            end_constraint_type: constraint,
            relaxable: false,
            order: 0,
            status: globalSolution.ActivityStatus.SCHEDULED,
            deliverable_as_origin: false,
            deliverable_as_destination: false,
            deliverable: false,
            deliver_to: '',
            deliver_from: '',
        };
    }
    function generateEmptyCandidateItem(id, preference, name, price, rating, categories, preferred) {
        if (name === void 0) { name = ''; }
        if (price === void 0) { price = { amount: 0, currency: globalSolution.CurrencyCode.USD }; }
        if (rating === void 0) { rating = 0; }
        if (categories === void 0) { categories = []; }
        if (preferred === void 0) { preferred = false; }
        var cat = categories.filter(function (x, index, self) { return self.indexOf(x) === index; });
        return {
            index: 0,
            categories: cat,
            description: '',
            explanations: [],
            rating: rating,
            preferred: preferred,
            types: [],
            tags: [],
            contexts: [],
            images: {
                small: '',
                medium: '',
            },
            id: id,
            name: name,
            price: price,
            prices: [price],
            source_id: '',
            photo: '',
            url: '',
            website: '',
            preference: preference,
        };
    }
    function generateEmptyProblem(activities, timezone) {
        if (activities === void 0) { activities = []; }
        if (timezone === void 0) { timezone = 'America/New_York'; }
        return {
            origin: null,
            destination: null,
            timezone: timezone,
            id: '',
            supplier_data: [],
            groups: [[]],
            agents: [],
            mode: globalSolution.PlannerConfigurationModes.GLOBAL,
            profile: null,
            activities: activities,
            current: null,
            flexible_ordering: true,
        };
    }
    function mapPOIToLocation(place, lat, lng, timeZone) {
        return {
            id: uuid.v4(),
            name: place.name,
            lat: lat,
            lng: lng,
            time_zone: timeZone,
            address_line1: '',
            address_line2: '',
            city: '',
            state_province: '',
            postal_code: '',
            country: '',
            address: place.formatted_address || '',
            url: '',
            website: '',
            photo: '',
        };
    }
    function generateEmptyPoiCandidate(id, arrival, departure, place, lng, lat, name, rating, timeZone, price, contexts, categories, preferred, preference) {
        if (name === void 0) { name = ''; }
        if (rating === void 0) { rating = 0; }
        if (timeZone === void 0) { timeZone = 'America/New_York'; }
        if (price === void 0) { price = {
            amount: 0,
            currency: globalSolution.CurrencyCode.USD,
        }; }
        if (contexts === void 0) { contexts = []; }
        if (categories === void 0) { categories = []; }
        if (preferred === void 0) { preferred = false; }
        var candiadate = generateEmptyCandidateItem(id, preference, name, price, rating, categories, preferred);
        return __assign(__assign({}, candiadate), { contexts: contexts, location: mapPOIToLocation(place, lat, lng, timeZone), start_timestamp: arrival ? Math.floor(arrival / 1000) : 0, end_timestamp: arrival ? Math.floor(departure / 1000) : 0 });
    }

    exports.convertActivityToRecommendation = convertActivityToRecommendation;
    exports.convertIntentToPreference = convertIntentToPreference;
    exports.generateEmptyActivityItem = generateEmptyActivityItem;
    exports.generateEmptyCandidateItem = generateEmptyCandidateItem;
    exports.generateEmptyPoiCandidate = generateEmptyPoiCandidate;
    exports.generateEmptyProblem = generateEmptyProblem;
    exports.getRecommendationContextFromActivity = getRecommendationContextFromActivity;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
